import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }

import PreviousActivitiesScorecardTotalTime from '../components/scorecards/PreviousActivitiesScorecardTotalTime.vue'
import PreviousActivitiesScorecardExpenses from '../components/scorecards/PreviousActivitiesScorecardExpenses.vue'
import PreviousActivitiesScorecardDistance from '../components/scorecards/PreviousActivitiesScorecardDistance.vue'
import { Timesheets } from '../types/timers'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviousActivitiesScorecardsAll',
  props: {
    timesheets: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PreviousActivitiesScorecardTotalTime, _normalizeProps(_guardReactiveProps(props)), null, 16)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PreviousActivitiesScorecardDistance, _normalizeProps(_guardReactiveProps(props)), null, 16)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(PreviousActivitiesScorecardExpenses, _normalizeProps(_guardReactiveProps(props)), null, 16)
    ])
  ], 64))
}
}

})